<template>
	<div :class="$style.notification">
		<BaseTooltip v-if="notification.date" position="right" :content="date">
			<TimeAgo
				:class="[$style['color'], $style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<p :class="$style['notification__title']" class="notification__title">
			{{ $t("notifications.types.partnership-action.title") }}
		</p>
		<p :class="$style['notification__notice']">
			<RouterLink
				:to="{
					name: 'Dashboard:Department',
					params: { id: notification.departmentId }
				}"
			>
				{{ notification.departmentName }}
			</RouterLink>
			<i18n path="notifications.types.partnership-action.message" tag="span">
				<RouterLink
					:to="{
						name: 'Dashboard:Department',
						params: { id: notification.partnershipDepartmentId }
					}"
				>
					{{ notification.partnershipDepartmentName }}
				</RouterLink>
			</i18n>
		</p>
		<div
			v-if="$auth().admin || $auth().managerRole"
			:class="$style['notification__buttons']"
		>
			<button
				:class="[
					$style['notification__button'],
					$style['notification__button--danger']
				]"
				@click="handleSubmit(false)"
			>
				<BaseRipple />
				{{ $t("common.actions.cancel") }}
			</button>
			<button :class="$style['notification__button']" @click="handleSubmit(true)">
				<BaseRipple />
				{{ $t("common.actions.confirm") }}
			</button>
		</div>
	</div>
</template>

<script>

import { mapActions } from '@/store/modules/Departments/helpers'
import { EDIT_PARTNERSHIP } from '@/store/modules/Departments/action-types'
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'

export default {
	name: 'PartnershipActionNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	computed: {
		date () {
			if (this.notification.date) {

				return moment(this.notification.date).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.date) {

				return new Date(this.notification.date).getTime()
			}
			return null
		}
	},
	methods: {

		...mapActions({
			editPartnership: EDIT_PARTNERSHIP
		}),

		async handleSubmit (status) {
			try {
				const payload = {
					id: this.notification.partnershipId,
					departmentId: this.$auth().selectedDepartmentId,
					status: status ? 'active' : 'declined'
				}
				await this.editPartnership(payload)
				this.$emit('success', this.notification)
			} catch (e) {
				this.$store.dispatch(
					'Notification/ADD_ERROR_NOTIFICATION',
					e
				)
			}
		}
	}
}
</script>
<style lang="scss" module>

.color {
    font-size: 12px;

    &--grey {
        color: getColor(caption);
    }
}

.notification {
    font-size: 14px;

    &__title {
        margin: 5px 0;
        font-size: 16px;
    }

    &__buttons {
        display: flex;
        padding-top: $gutter;
    }

    &__notice {
        margin: 0 0 10px;
        font-size: 14px;
        color: getColor(helper-text);
    }

    &__message {
        margin: 0 0 10px;
        font-size: 14px;
        color: getColor(helper-text);
    }

    &__button {
        display: flex;
        align-items: center;
        appearance: none;
        font-size: 14px;
        border-radius: 4px;
        color: getColor(tertiary);
        text-decoration: none;
        padding: $gutter $gutter * 2;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        border: 1px solid lighten(var(--tertiary), 15%);
        background-color: transparentize(var(--grey), 0.9);
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

        &:hover {
            background-color: transparentize(var(--tertiary), 0.9);
            color: lighten(var(--tertiary), 15%);
        }

        &:active,
        &:focus {
            outline: 0;
        }

        &:nth-child(2) {
            margin-left: 10px;
        }

        &--danger {
            color: getColor(danger);
            background-color: transparentize(var(--grey), 0.9);
            border: none;

            &:hover {
                background-color: transparentize(var(--danger), 0.9);
                color: lighten(var(--danger), 15%);
            }
        }
    }

    &__button-icon {
        margin-left: 7.5px;
        font-size: 16px;
    }
}
</style>
